import { AfterViewInit, Component, Input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ReferrerPortalService } from '../referrer-portal.service';
import { StaticDataService } from 'src/app/services/static-data.service';
import { ReferralDataModel } from '../../configuration/referral-configuration/models/referral-data.model';
import { TdoTableSelectionEvent } from 'src/app/tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { FileManagerService } from '../../file-manager/file-manager.service';
import { DocumentClassEnum } from 'src/app/models/enum/document/document-class.enum';
import { MessagingService } from 'src/app/services/messaging.service';
import { ToastrService } from 'ngx-toastr';
import { TdoOrganizerSlideshowDialogComponent } from 'src/app/main-interface/organizer/dialogs/tdo-organizer-slideshow-dialog/tdo-organizer-slideshow-dialog.component';

@Component({
  selector: 'app-referrer-portal-referral-detail',
  templateUrl: './referrer-portal-referral-detail.component.html',
  styleUrls: ['./referrer-portal-referral-detail.component.css']
})
export class ReferrerPortalReferralDetailComponent implements AfterViewInit {

  @Input() set referral(value: ReferralDataModel){
    this.currentReferral = value;
    this.init();
  };
  currentReferral : ReferralDataModel;
  referrerId: string;
  referrerInformation: any = {};

  isLoadingPrescriptions: boolean = true;
  isLoadingReports: boolean = true;
  isLoadingNotes: boolean = true;
  isLoadingRecallNotes: boolean = true;
  isLoadingImages: boolean = true;

  referralPrescriptions: any;
  referralReports: any;
  referralNotes: any;
  referralRecallNotes: any;
  referralImages: any;
  imageThumbnails: any;
  
  LOCID = parseInt(localStorage.getItem('LOCID'));

  constructor(
    private readonly staticDataService: StaticDataService,
    private readonly referrerPortalService: ReferrerPortalService,
    private readonly dialog: MatDialog,
    private readonly fileManagerService: FileManagerService,
    private readonly messagingService: MessagingService,
    private readonly toastr: ToastrService
  ) {
    this.referrerInformation = JSON.parse(localStorage.getItem('storedReferrerUser'));
    this.referrerId = this.referrerInformation.authdata.doctorId;
  }

  ngAfterViewInit() {

    if (!this.staticDataService.isReady) {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.init();

        }
      });
      this.staticDataService.refreshValues();
    }
    else
      this.init();

  }

  init() {
    if (this.currentReferral) {      
      this.isLoadingPrescriptions = true;
      this.isLoadingReports = true;
      this.isLoadingNotes = true;
      this.isLoadingRecallNotes = true;
      this.isLoadingImages = true;
      this.referralPrescriptions = null;
      this.referralReports = null;
      this.referralNotes = null;
      this.referralRecallNotes = null;
      this.referralImages = null;
      this.imageThumbnails =null;
      this.GetReferralPrescriptions();
      this.GetFinalReportNotes();
      this.GetRecallNotes();
      this.GetReferreralImages();
      this.GetReferreralReports();
    }
  }

  private GetReferralPrescriptions() {
    return this.referrerPortalService.getReferreralPrescriptions(this.referrerId, this.currentReferral.ReferralID).subscribe(
      result => {
        if (result){
          this.referralPrescriptions = result;
        }
      },
      error => {
        this.displayMessage("Error", "Error getting Referral prescriptions.");
      },

      () => {
        this.isLoadingPrescriptions = false;

      }
    );
  }

  private GetReferreralImages() {
    return this.referrerPortalService.getReferreralImages(this.referrerId, this.currentReferral.ReferralID).subscribe(
      result => {
        if (result){
          result.forEach(image => {
            image.src = this.fileManagerService.getDocumentImageUrl(this.currentReferral.Appointment.PatientId, image.DocumentFileName);
          }
          );
          this.referralImages = result;
          this.imageThumbnails = this.referralImages.filter(i => i.enumDocumentClassID === DocumentClassEnum.Thumbnail);
        }
      },
      error => {
        this.displayMessage("Error", "Error getting Referral images.");
      },

      () => {
        this.isLoadingImages = false;
      }
    );
  }

  private GetReferreralReports() {
    return this.referrerPortalService.getReferreralReports(this.referrerId, this.currentReferral.ReferralID).subscribe(
      result => {
        if (result)
          this.referralReports = result;
      },
      error => {
        this.displayMessage("Error", "Error getting Referral reports.");
      },

      () => {
        this.isLoadingReports = false;
      }
    );
  }

  private GetFinalReportNotes() {
    return this.referrerPortalService.getReferreralNotes(this.referrerId, this.currentReferral.ReferralID, "finalreport").subscribe(
      result => {
        if (result) {
          this.referralNotes = result;
        }
      },
      error => {
        this.displayMessage("Error", "Error getting Referralnotes.");
      },

      () => {
        this.isLoadingNotes = false;
      }
    );
  }

  private GetRecallNotes() {
    return this.referrerPortalService.getReferreralNotes(this.referrerId, this.currentReferral.ReferralID, "recall").subscribe(
      result => {
        if (result) {
          this.referralRecallNotes = result;
        }
      },
      error => {
        this.displayMessage("Error", "Error getting Referral Recall notes.");
      },

      () => {
        this.isLoadingRecallNotes = false;
      }
    );
  }

  displayMessage(type, message) {

    if (type.toLowerCase() === "error")
      this.toastr.error(message, null, {timeOut:7000});
    else
      this.toastr.success(message, null, {timeOut:3000});      

  }

  onPrescriptionSelected (event: TdoTableSelectionEvent) {
  }

  onImageSelected (event: TdoTableSelectionEvent) {
    console.log("Image selected:", event);
  }

  onReportSelected (event: TdoTableSelectionEvent) {
    console.log("Report selected:", event);
  }

  onNoteSelected (event: TdoTableSelectionEvent) {
  }  
  
  onReferralRecallNoteSelected (event: TdoTableSelectionEvent) {
  }

  getTagValue(validValueId:string){
    return this.staticDataService.getValidValueItemByItemId(validValueId)?.ItemDisplayValue;
  }

  openImage(image:any){
    const parent = this.referralImages.find(i => i.DocumentID === image.ParentDocumentID);
    if (!parent){
      this.displayMessage("Error", "Full size image not found.");
      return;
    }
    let windowOptions = [
      'toolbar=no',
      'location=no',
      'menubar=no',
      'height=' + screen.height,
      'width=' + screen.width,
      'fullscreen=yes' // only works in IE, but here for completeness
    ].join(',');
    const imageHref=`javascript: document.body.innerHTML="<style>div { width:100%; height:100%; background-image: url('${location.origin}${parent.src}'); background-size: contain;  background-repeat: no-repeat;background-position: center;}</style><div></div>"`;
    this.messagingService.openPopUpWindow(imageHref, windowOptions, parent.DocumentFileName, "", null, true, parent.DocumentFileName);
  }

  openReport(report:any){
    console.log("Opening report:", report);

      let documentIds: string[] = [];
      documentIds.push(report.model.DocumentID);
  
      const config = new MatDialogConfig();
      config.panelClass = 'standard-dialog';
      config.data = documentIds;
      config.maxWidth = '100vw';
      config.maxHeight = '100vh';
      config.width = '98%';
      config.height = '98%';
      console.log('ReferrerPortalReferralDetailComponent openReport:', config);
      this.dialog.open(TdoOrganizerSlideshowDialogComponent, config).afterClosed().subscribe((res) => {
        //
      });    
  }
}
